var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-1"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.value.Content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }